import styled from "styled-components";
import { media } from "src/styles/mixins";
import ButtonBordered from "src/components/shared/Button/ButtonBordered";
import {
  defaultCard,
  defaultCardWithText,
} from "src/components/shared/Cards/sharedStyles";

export const TaskBoardWrapper = styled.div`
  padding: 10px;
  height: 180px;
  border-radius: 12px;
  width: 100%;
  border: ${({ theme }) =>
    `${theme.border.thin} solid ${theme.colors.primary}`};
  margin: 15px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  ${media.down("LAPTOP")`
    justify-self:center;
  `}

  ${media.up("TABLET")`
    width: 440px;
    height: 240px;
  `}
`;

export const TaskGameName = styled.div`
  color: ${({ theme }) => theme.colors.primary70};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  display: none;
`;

export const ShowCardsButton = styled(ButtonBordered)`
  width: 208px;

  ${media.down("MOBILE_EXTRA_SMALL")`
    width:100%;
  `}
`;

export const TaskName = styled.div<{ isInactive?: boolean }>`
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xxxs};
  word-break: break-word;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;

  ${media.down("LAPTOP")`
    -webkit-line-clamp: 1;
    width: 100%;
  `}

  ${({ theme }) => media.up("LAPTOP")`
    font-size: ${theme.fonts.sizes.s};
    line-height: ${theme.fonts.lineHeights.xs};
    height: ${theme.fonts.lineHeights.xs};
  `};
`;

export const TaskStateText = styled.div`
  margin-top: 48px;

  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};

  ${media.up("LAPTOP")} {
    font-size: ${({ theme }) => theme.fonts.sizes.base};
  }
`;

export const TaskCardLabel = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.xxxxs};
  font-weight: ${({ theme }) => theme.fonts.weights.medium};
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary70};
`;

export const TaskCard = styled.div`
  ${defaultCard}
  ${defaultCardWithText}
  background-color: ${({ theme }) => theme.colors.cards.fills.active};
  border: ${({ theme }) => theme.border.thin} solid
    ${({ theme }) => theme.colors.cards.borders.primary};

  ${media.down("TABLET")`
    width: 32px;
    height: 56px;
  `}
`;
